module.exports = __webpack_public_path__ + "img/patrick.19713166.jpg";